<template>
    <div :class="ClaseContenedorMarcadorResultados()">
      {{MiNombre}} <b>{{DatosMarcador.Ganadas}}</b>  -  <b>{{DatosMarcador.Perdidas}}</b> Others

      <div class="ContenedorPanel" v-show="false">
          <div class="ContenedorTitulo">Edit Score</div>
          <div class="ContenedorBotones">
            <div class="BotonesLeft">
                <div class="Boton BotonRojo noselect" @click="DescontarWin()">&#8595;</div> <div class="Boton BotonVerde noselect" @click="AumentarWin()">&#8593;</div> 
            </div>
            <div class="BotonReset noselect" @click="ResetearMarcador()">Reset</div>
            <div class="BotonesRight">
                <div class="Boton BotonRojo noselect" @click="DescontarDerrota()">&#8595;</div> <div class="Boton BotonVerde noselect" @click="AumentarDerrota()">&#8593;</div> 
            </div>
          </div>
      </div>
    </div>
</template>

<script>
import Utilities from "../Utilities/Utilities.js";
export default {
    name:"MarcadorResultados",
    props:{
        //Solo1v1: Boolean
    },
    data(){
        return {
            MiNombre: "",
            _ProfileID: "",
            DatosMarcador: {
                Ganadas:0,
                Perdidas:0
            },
            RatingActual: null,
            RatingOverlay: null
        }
    },
    mounted(){

        // fetch('https://api.ipify.org?format=json', function(data){
        //     console.log(data);
        //     console.log(data.ip);
        // });
        // fetch('https://api.ipify.org?format=json')
        // // fetch('http://ip-api.com/json')
        // .then(r => r.json())
        // .then(json => {
        //     console.log(json);
        //     console.log(json.ip);
        // });
    },
    methods: {
        ArrancarMarcador(_Nombre, _ProfileID, _Reseteo){
            this._ProfileID = _ProfileID;
            
            var _Aux = Utilities.RecuperarJsonDeStorage(this.Key(this._ProfileID));
            if(_Aux){
                this.DatosMarcador = _Aux;
            } 

            if(_Reseteo){
                this.ResetearMarcador();
                window.location.href = window.location.href.replace("&resetscore", "");
            }

            this.MiNombre = _Nombre;
            this.ChequearRating();
        },
        async ChequearRating(){
            //var _Rating = await this.ObtenerRating();
            if (this.RatingActual == null){
                this.RatingActual = this.RatingOverlay;
            }else{
                if (this.RatingOverlay > this.RatingActual){
                    this.DatosMarcador.Ganadas += 1;
                    Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
                    console.log(this.RatingActual + "---> " + this.RatingOverlay);
                    this.RatingActual = this.RatingOverlay;
                }else if (this.RatingOverlay < this.RatingActual){
                    this.DatosMarcador.Perdidas += 1;
                    Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
                    console.log(this.RatingActual + "---> " + this.RatingOverlay);
                    this.RatingActual = this.RatingOverlay;
                }
            }
            setTimeout(() => { this.ChequearRating(); }, 10 * 1000);
        },
        ActualizarRatingOverlay(_Rating){
            this.RatingOverlay = _Rating;
        },
        async ObtenerRating(){
            var _Retorno = 0;
            try {
                const _Promesa = await fetch("https://aoe2.net/api/player/ratinghistory?game=aoe2de&leaderboard_id=3&profile_id=" + this._ProfileID + "&count=1");
                const _Resultado = await _Promesa.json();
                _Retorno = _Resultado[0].rating;
            } catch (e) {
                console.log(e);
            }
            return _Retorno;
        },
        Key(_ProfileID){
            return "DatosMarcador_" + _ProfileID;
        },
        ClaseContenedorMarcadorResultados(){
            var _Retorno = "ContenedorMarcadorResultados";
            if(this.MiNombre != ""){
                _Retorno += " Visible";
            }
            return _Retorno;
        },
        DescontarWin(){
            if(this.DatosMarcador.Ganadas > 0){
                this.DatosMarcador.Ganadas -=1;
                Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
            }
        },
        AumentarWin(){
            this.DatosMarcador.Ganadas +=1;
            Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
        },
        DescontarDerrota(){
            if(this.DatosMarcador.Perdidas > 0){
                this.DatosMarcador.Perdidas -=1;
                Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
            }
        },
        AumentarDerrota(){
            this.DatosMarcador.Perdidas +=1;
            Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
        },
        ResetearMarcador(){
            this.DatosMarcador.Ganadas = 0;
            this.DatosMarcador.Perdidas = 0;
            Utilities.GuardarJsonEnStorage(this.Key(this._ProfileID), this.DatosMarcador);
        },

    }
}

class ResultadoPartida {
  constructor(_Partido) {
    this._Id = 0;
    this._Ganada = null;
    this._Partido = _Partido;
    if(_Partido){
        this._Id = _Partido.match_id;
        this._Ganada = _Partido.players[0].won;
    }
  }
};
</script>

<style scoped lang="scss">
    .ContenedorMarcadorResultados{
        position:absolute;
        bottom:-115px;
        height:50px;
        line-height:42px;
        font-size:38px;
        padding:10px 40px;
        width:fit-content;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: green;
        border-radius:0 0 40px 40px;
        background-image: url("../assets/hex.png");
        background-repeat: repeat;
        box-shadow:inset 0 0 20px #000;
        border:4px solid #000;
        opacity: 0;
        transition: all 1s;
    }
    .Visible{
        opacity: 1;
    }
    .ContenedorPanel{
        position:relative;
        width: 100%;
        //   height:50px;
        //   line-height:50px;
        margin-top:100px;
        background-color: #000;
            color:#CCC;
    }
    .ContenedorTitulo{
            width:100%;
            // height: 30px;
            line-height: 30px;
            // font-size:22px;
            border:1px solid #AAA;
            border-bottom:none;
            box-sizing: border-box;
            padding:10px 0;
    }
    .ContenedorBotones{
            display:flex;
            align-content: space-between;
            border:1px solid #AAA;
            padding:5px 0;
    }
    .BotonesLeft{
            width:50%;
            box-sizing: border-box;
            padding:2px 10px;
            display: flex;
        }
    .BotonesRight{
            width:50%;
            box-sizing: border-box;
            padding:2px 10px;
            display: flex;
            justify-content: flex-end;
        }
    .Boton{
        // width:50px;
        height: 50px;
        padding:0 15px;
        background-color:black;
        border-radius:50%;
        box-sizing: border-box;
        font-weight: bold;
        text-align: center;
        margin: 0 5px;
        cursor: pointer;
        outline: none;
    }
    .BotonVerde{
        color: #00D815;
        border:2px solid #00D815;
        &:hover{
            box-shadow: 0 0 10px #00D815;
        }
    }
    .BotonRojo{
        color: #FF0000;
        border:2px solid #FF0000;
        &:hover{
            box-shadow: 0 0 10px #FF0000;
        }
    }
    .BotonReset{
        cursor: pointer;
        font-size:30px;
        &:hover{
            text-decoration: underline;
        }
    }

</style>